/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-nested-ternary */
import { Popover } from 'antd';
import PeopleWidgetWithOutHolo from 'Components/common/components/PeopleWidgetWithOutHolo';
import styled from 'styled-components';
// import { TeamDetailResult } from 'Types/SRITypes';
// import { backgroundColorParsing } from 'Utils/UtilityFunctions';
import {
  boxShadow,
  maxWidth,
  primaryColor, midWidthApp,
  primaryFont, retina, wMBold, wMedium,
} from 'Utils/utilsStyle';
import { formatNumberWithCommas } from 'Utils/UtilityFunctions';
import SriScoreCard from './SriScoreCard';

const Body = styled.div`
  display: flex;
  align-items: center;
  box-shadow: ${boxShadow};
  border-radius: 10px;
  background: #fff;
  padding: 18px 14px;
  margin-bottom: 10px;
  &.region-table-body {
    .body-item {
      &:nth-child(1) {
        min-width: 10%;
        width: 10%;
        text-align: center;
      }
      &:nth-child(2) {
        min-width: 30%;
        width: 30%;
        text-align: center;
      }
      &:nth-child(3) {
        min-width: 20%;
        width: 20%;
        text-align: center;
      }
      &:nth-child(4), &:nth-child(5) {
        min-width: 20%;
        width: 20%;
        text-align: center;
      }
    }
  }
  &.team-table-body {
    .body-item {
      padding: 0 10px;
      &:nth-child(2) {
        padding: 0px;
      }
      .beltImage {
        margin-left: 0px;
      }
    }
  }
    .body-item {
      min-width: 20%;
      width: 20%;
      font-size: 20px;
      font-weight: ${wMBold};
      font-family: ${primaryFont};
      color: #424B50;
      @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 16px;
      }
      .person-title {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      &:nth-child(1) {
        min-width: 105px;
        width: 105px;
      }
      &:nth-child(2) {
        min-width: calc(40% - 245px);
        width: calc(40% - 245px);
        @media all and (max-width: ${maxWidth}) , ${retina} {
          min-width: calc(50% - 215px);
          width: calc(50% - 215px);
        }
      }
      &:nth-child(3) {
        min-width: calc(60% - 325px);
        width: calc(60% - 325px);
        @media all and (max-width: ${maxWidth}) , ${retina} {
          min-width: calc(50% - 215px);
          width: calc(50% - 215px);
        }
      }
      &:nth-child(4) {
        min-width: 155px;
        width: 155px;
        @media all and (max-width: ${maxWidth}) , ${retina} {
          min-width: 105px;
          width: 105px;
        }
      }
      &:nth-child(5) {
        min-width: 155px;
        width: 155px;
        @media all and (max-width: ${maxWidth}) , ${retina} {
          min-width: 130px; 
          width: 130px;
        }
      }
      &:nth-child(6) {
        min-width: 155px;
        width: 155px;
        @media all and (max-width: ${maxWidth}) , ${retina} {
          min-width: 90px;
          width: 90px;
        }
      }
      .beltImage {
        width: 69px;
        margin-left: 25px;
      }
      .person-title {
        display: block;
        margin-left: 10px;
        font-size: 20px;
        width: 100%;
        white-space: normal;
        &:hover {
          cursor: pointer;
        }
        @media all and (max-width: ${maxWidth}) , ${retina} {
          font-size: 16px;
      }
      &.body-accounts {
        font-size: 16px;
        color: ${primaryColor};
        font-weight: ${wMedium};
      }
    }
  }
  .ant-popover  {
    z-index: 1;
    /* left: 500px !important; */
  }
  .ant-popover-inner-content {
    padding: 0px !important;
  }
  .ant-popover-inner {
    border-radius: 8px !important;
  }
`;

type Props = {
  beltLevel?: string,
  personImg?: string,
  data: { [key: string]: any },
  keys: string[],
  setRegion?: ({ key }: { key: string }) => void;
  setTeam?: ({ key }: { key: string }) => void;
  setUser?: (userId: number) => void;
  filterType?: string;
} & typeof defaultProps;

const defaultProps = {
  beltLevel: '',
  personImg: '',
  setRegion: ({ key }: { key: string }) => { console.log(key); },
  setTeam: ({ key }: { key: string }) => { console.log(key); },
  setUser: (userId: number) => { console.log(userId); },
  filterType: '',
};

const TeamReadinessTableBody = function TeamReadinessTableBody(props: Props) {
  const {
    data, keys, beltLevel, personImg, setRegion, filterType,
    setTeam, setUser,
  } = props;

  const onClickHandler = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    if (filterType === 'multiple_regions') {
      setRegion({ key: data?.name });
    } else if (filterType === 'multiple_teams') {
      setTeam({ key: data?.team_id?.toString() });
    } else if (filterType === 'single_team') {
      setUser(data?.user_id);
    }
  };

  function widget(item: string) {
    return !personImg ? (
      <div className="body-item d-flex align-items-center">
        <span
          className="person-title"
          onClick={onClickHandler}
        >
          {data[item]}
        </span>
      </div>
    ) : (

      <div className="body-item d-flex align-items-center">
        <Popover
          content={<SriScoreCard data={data.score_breakdown_results} />}
          trigger="hover"
          key={data[item]}
          getPopupContainer={(e: HTMLElement) => e}
          placement="right"
          className="d-flex align-items-center"
          arrow={false}
        >
          <div className="ml-c-20">
            <PeopleWidgetWithOutHolo
              diameter="54px"
              diameterSm="40px"
              diameterXsm="40px"
              ringPadding="2px"
              ringPaddingSm="2px"
              margin="4px 0px"
              logo={personImg}
              personId={0}
            />
          </div>
          <div
            className="body-item person-title"
            onClick={onClickHandler}
          >
            {data[item]}
          </div>
        </Popover>
      </div>

    );
  }

  return (
    <Body className={`${!personImg ? 'region-table-body' : 'team-table-body'}`}>
      {keys?.map((item) => (
        item === 'name'
          ? (
            widget(item)
          ) : item === 'level'
            ? (
              <div className="body-item">
                <img src={beltLevel} alt="belt" className="beltImage" />
              </div>
            ) : item === 'score'
              ? (
                <div className="body-item">
                  {formatNumberWithCommas(data[item])}
                </div>
              )
              : <div className="body-item">{data[item]}</div>
      ))}
    </Body>
  );
};

TeamReadinessTableBody.defaultProps = defaultProps;
export default TeamReadinessTableBody;
